import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getPractice } from '../../common';

export const useServiceLocation = (userType, token) => {
  const dispatch = useDispatch();
  const practiceDetails = useSelector(state => state.practiceDetails);
  const practice = practiceDetails.practice;
  
  // Track if we've already fetched practice data to prevent infinite loop
  const hasFetchedPractice = useRef(false);
  
  const [selectedServiceLocation, setSelectedServiceLocation] = useState('');
  const [serviceLocations, setServiceLocations] = useState([]);
  const [selectedLocationAddress, setSelectedLocationAddress] = useState('');

  // Format service location address
  const formatServiceLocationAddress = (location) => {
    const address = location.service_address || {};
    const parts = [
      address.street1,
      address.street2,
      address.city,
      address.state,
      address.zip_code
    ].filter(Boolean);
    return parts.join(', ');
  };

  // Fetch practice data - prevent infinite loop
  useEffect(() => {
    if (practice && practice._id && token && userType === 'staff' && !hasFetchedPractice.current) {
      console.log('=== useServiceLocation: Fetching practice data (first time only) ===');
      hasFetchedPractice.current = true;
      getPractice(practice._id, dispatch, token);
    }
  }, [practice?._id, token, dispatch, userType, practice]); // Include practice for proper dependency tracking

  // Update service locations when practice data changes
  useEffect(() => {
    console.log('=== USE SERVICE LOCATION DEBUG ===');
    console.log('Practice exists:', !!practice);
    console.log('Practice services:', practice?.practice_service?.length || 0);
    console.log('Selected service location:', selectedServiceLocation);
    
    if (practice && practice.practice_service) {
      const activeServices = practice.practice_service.filter(service => !service.is_deleted);
      console.log('Active services:', activeServices.length);
      setServiceLocations(activeServices);
      
      // Set default selection to first service if available
      if (activeServices.length > 0 && !selectedServiceLocation) {
        const firstServiceId = activeServices[0]._id;
        console.log('Auto-selecting first service:', firstServiceId);
        console.log('First service details:', activeServices[0]);
        
        setSelectedServiceLocation(firstServiceId);
        setSelectedLocationAddress(formatServiceLocationAddress(activeServices[0]));
        
        // Dispatch service selection to update appointments view
        console.log('Dispatching selectServiceForAppointments with:', firstServiceId);
        dispatch({
          type: 'selectServiceForAppointments',
          payload: firstServiceId
        });
      } else {
        console.log('Service already selected or no active services');
      }
    }
    console.log('=== END USE SERVICE LOCATION DEBUG ===');
  }, [practice, practice?.practice_service, selectedServiceLocation, dispatch]);
  
  // Handle service location change
  const handleServiceLocationChange = (serviceId) => {
    setSelectedServiceLocation(serviceId);
    
    if (practice) {
        const selectedLocation = serviceLocations.find(loc => loc._id === serviceId);
        if (selectedLocation) {
          setSelectedLocationAddress(formatServiceLocationAddress(selectedLocation));
        }
    }
    
    // Dispatch service selection to appointments view
    dispatch({
      type: 'selectServiceForAppointments',
      payload: serviceId
    });
  };

  return {
    selectedServiceLocation,
    serviceLocations,
    selectedLocationAddress,
    handleServiceLocationChange
  };
};
